import { Typography } from "@mui/material";

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600, mb: 0.25, display: "block" }}>
    {children}
  </Typography>
);

export default FieldLabel;
